import router from './router/index'
import store from './store/index'
import { getStore } from '@/util/storage'
import authCode from '@/util/auth_code' //权限码获取

export function hasAuth(authName) {
  let value = authCode[authName]

  if (!authName || !value) {
    return true
  } else {
    let userInfo = getStore('orientUser')
    if (!userInfo) {
      return false
    }

    let code = value.pAuthCode
    let userAuthCodes = []
    let codes = userInfo.auth_codes

    if (codes && codes.length > 0) {
      userAuthCodes = codes[0].Codes
    }

    if (code == "") {
      return false
    }

    if (userInfo.is_super_admin) {
      return true
    }
    return userAuthCodes.includes(code)
  }
}

export function hasOneOfAuths(authNames) {
  var res = false
  for (let index = 0; index < authNames.length; index++) {
    const item = authNames[index];
    res = hasAuth(item)
    if (res) break
  }
  return res
}

const whiteList = ['/login'] // no redirect whitelist

router.beforeEach((to, from, next) => {
  let userInfo = getStore('orientUser')
  if (to.meta.authName) {
    if (!hasAuth(to.meta.authName)) {
      alert('权限不足')
      next({ path: '/dashboard' })
    }
  }

  if (to.meta.title == '404') {
    store.commit('logout')
    next({ path: '/login' })
    return
  }

  if (to.meta.title) {
    document.title = to.meta.title
  }


  if (whiteList.indexOf(to.path) !== -1) {
    if (to.path == '/login' && userInfo) {
      next({ path: '/dashboard' })
    } else {
      next()
    }
    return
  } else {
    if (!userInfo) {
      store.commit('loginRedirect', to.fullPath)
      next({ path: '/login' })
      return
    }
  }

  store.commit('login', userInfo)

  if (to.path == '/dashboard') {
    next({ path: '/dashboard/home' })
  } else {
    next()
  }
})
